<template>
  <div class="window-right" :class="{ open: open }">
    <MenuBox
      :title="offer ? 'Bieżąca oferta' : 'Koszyk'"
      @clickButtonMenu="clickMinMenu()"
    >
      <template slot="icon">
        <close-box-outline-icon />
      </template>
      <BasketRight v-if="!offer" />
      <OfferRight v-if="offer" />
    </MenuBox>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { storeEmitter } from "../../state/store";
import MenuBox from "./../layout/src/navigation/MenuBox.vue";
import CloseBoxOutlineIcon from "vue-material-design-icons/CloseBoxOutline.vue";

import BasketRight from "./../basket/src/BasketRight.vue";
import OfferRight from "./../offer/src/OfferRight.vue";

export default {
  components: {
    CloseBoxOutlineIcon,
    MenuBox,
    BasketRight,
    OfferRight
  },
  computed: {
    ...mapState({
      open: state => state.showRightWindow,
      offer: state => state.showRightWindowOffer
    })
  },

  data() {
    return {
      scrollY: false
    };
  },

  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    clickMinMenu() {
      this.$store.dispatch("closeRightWindow");
    }
  },

  beforeMount() {
    this.scrollY = window.scrollY;
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/RightWindow.vue